<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('paddle_number')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="paddle_number"/>
            </div>
            <template v-if="!excludeSearchFields.includes('uuid')">
              <div class="input-wrapper" v-if="enableContinuousAuction">
                <customer-select-input-widget @select="onCustomerSelect"
                                              :model="searchModel"
                                              :label="false"
                                              :options="{placeholder: $t('Customer')}"
                                              attribute="customer_uuid" is-search/>
              </div>
              <div v-else class="input-wrapper">
                <bidder-select-input-widget @select="onBidderSelect"
                                            :model="searchModel"
                                            :label="false"
                                            :auction-uuid="extraFilters.auction_uuid"
                                            :options="{placeholder: $t('Bidder')}"
                                            value-field="uuid"
                                            attribute="uuid" is-search/>
              </div>
            </template>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('sale_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="sale_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('company_name')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="company_name"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('status')">
              <bidder-status-select-input-widget :model="searchModel" attribute="status"
                                                 :label="false" :options="{placeholder: $t('Approval Status')}"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('client_tier')">
              <client-tier-select-input-widget :model="searchModel" attribute="client_tier"  :label="false"
                            :options="{placeholder: $t('Client Tier')}"/>
            </div>
            <customer-identification-filters :search-model="searchModel" :filters="identityFieldsFilters" />
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('negotiation_bidder')">
              <input-widget :model="searchModel" attribute="negotiation_bidder" type="checkbox"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('identity_verification')">
              <input-widget :model="searchModel" :label="false" :options="{placeholder: $t('Identity Verification')}"
                            display-field="${item.key}" attribute="identity_verification" type="select2" value-field="value"
                            :items="identityVerificationTypes"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('kyc_status_verification')">
              <input-widget :model="searchModel" :label="false" :options="{placeholder: $t('Account/KYC Verification')}"
                            display-field="${item.key}" attribute="kyc_status_verification" type="select2" value-field="value"
                            :items="kycVerificationTypes"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('winners')">
              <input-widget :model="searchModel" attribute="winners" type="checkbox"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import BidderSelectInputWidget from "@/core/widgets/BidderSelectInputWidget";
  import CustomerSelectInputWidget from "@/core/widgets/CustomerSelectInputWidget";
  import CustomerIdentificationFilters from "../customer/CustomerIdentificationFilters.vue";
  import BidderStatusSelectInputWidget from "@/core/widgets/BidderStatusSelectInputWidget";
  import ClientTierSelectInputWidget from "@/core/widgets/ClientTierSelectInputWidget.vue";

  const {mapState, mapActions} = createNamespacedHelpers('bidders');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "BidderSearch",
    components: {
      ClientTierSelectInputWidget,
      BidderStatusSelectInputWidget,
      CustomerIdentificationFilters, CustomerSelectInputWidget, BidderSelectInputWidget, InputWidget,},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
        identificationFieldsFilters: state => state.identificationFieldsFilters,
        identityVerificationTypes: state => state.identityVerificationTypes,
        kycVerificationTypes: state => state.kycVerificationTypes,
      }),
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        extraFilters: state => state.tableData[state.tableSource].extraFilters,
      }),
      identityFieldsFilters() {
        let result = [];

        if (this.identificationFieldsFilters) {
          let identityFieldsFilters = this.identificationFieldsFilters.bidders;
          if (identityFieldsFilters && identityFieldsFilters.length > 0) {
            result = identityFieldsFilters;
          }
        }

        return result;
      },
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
      async onBidderSelect(bidder) {
        this.updateSearchModel({bidder});
      },
      async onCustomerSelect(customer) {
        this.updateSearchModel({customer});
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
